import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { PHOTO_CARD_DETAIL } from '@src/queryKeys';
import photoCardsApiV2 from '@src/apis/photoCardsApiV2';
import { validate as uuidValidate } from 'uuid';

/**
 * 포토 카드 ID에 해당하는 포토 카드 상세 정보 반환
 * */
const useGetPhotoCardInfoById = ({
  photoCardId,
}: {
  photoCardId?: string;
}): UseQueryResult<PhotoCardType> => {
  return useQuery<PhotoCardType>({
    queryKey: [PHOTO_CARD_DETAIL, photoCardId],
    queryFn: async () => {
      const res = await photoCardsApiV2.getPhotoCardDetail({
        photoCardId: photoCardId as string,
      });
      return res.data;
    },
    enabled: !!photoCardId && uuidValidate(photoCardId),
    retry: 1,
  });
};

export default useGetPhotoCardInfoById;
